import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Alert,
  Button, Card, Col, Row,
} from 'react-bootstrap';
import Background from '../../blanks/common/Background';
import Flex from '../../blanks/common/Flex';
import Section from '../../blanks/common/Section';
import bgShape from '../../../assets/img/illustrations/bg-shape.png';
import shape1 from '../../../assets/img/illustrations/shape-1.png';
import halfCircle from '../../../assets/img/illustrations/half-circle.png';

function AuthCardLayout({
  leftSideContent,
  children,
  handleSwitchMethod,
  loginMethod,
  hideSwitchLoginMethod = false,
}) {
  return (
    <Section fluid className="py-0">
      <Row className="g-0 min-vh-100 flex-center">
        <Col
          lg={loginMethod === 'KEP' ? 9 : 8}
          xxl={loginMethod === 'KEP' ? 6 : 5}
          className="py-3 position-relative"
        >
          <img
            className="bg-auth-circle-shape"
            src={bgShape}
            alt=""
            width="250"
          />
          <img
            className="bg-auth-circle-shape-2"
            src={shape1}
            alt=""
            width="150"
          />
          <Card className="overflow-hidden z-index-1">
            <Card.Body className="p-0">
              <Row className="h-100 g-0">
                <Col md={5} className="text-white text-center bg-card-gradient">
                  <div className="position-relative p-4 pt-md-5 pb-md-7">
                    <Background
                      image={halfCircle}
                      className="bg-auth-card-shape"
                    />
                    <div className="z-index-1 position-relative light">
                      <Link
                        className="link-light mb-4 font-sans-serif fw-bolder fs-4 d-inline-block"
                        to="/"
                      >
                        Є-Пічник
                      </Link>
                      <p
                        className="opacity-75 text-white"
                      >
                        Сучасна інформаційно-комунікаційна система,
                        розроблена спеціально для суб&#39;єктів господарювання,
                        що виконують технічне обслуговування ДВК.
                      </p>
                      <p className="opacity-75 text-white">
                        Ваша гарантія відповідності новим правилам!
                      </p>
                    </div>
                  </div>
                  <div className="mt-3 mb-4 mt-md-4 mb-md-5 light">
                    {leftSideContent}
                    {!hideSwitchLoginMethod && (
                    <>
                      <Alert variant="warning" className="mt-2">
                        {/* eslint-disable-next-line max-len */}
                        Якщо Ви використовуєте авторізацію за КЕП, або двухфакторну авторизацію (Спочатку КЕП),
                        натисніть кнопку нижче для зміни способу входу.
                      </Alert>

                      <Button
                        variant="light"
                        className="mt-2"
                        onClick={handleSwitchMethod}
                      >
                        {loginMethod === 'KEP' ? 'Увійти за логіном та паролем' : 'Увійти за КЕП'}
                      </Button>
                    </>
                    )}
                  </div>
                </Col>
                <Col
                  md={7}
                  as={Flex}
                  alignItems="center"
                  justifyContent="center"
                >
                  <div className="p-3 p-md-3 flex-grow-1">{children}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
}
AuthCardLayout.propTypes = {
  leftSideContent: PropTypes.node,
  children: PropTypes.node.isRequired,
  loginMethod: PropTypes.string.isRequired,
  handleSwitchMethod: PropTypes.func.isRequired,
  hideSwitchLoginMethod: PropTypes.bool,
};

AuthCardLayout.defaultProps = {
  leftSideContent: null,
  hideSwitchLoginMethod: false,
};

export default AuthCardLayout;
